import { STATUS_TYPE } from '../../../enum';
import { Flavor } from '../../flavor/api/interface';
import { Shape } from '../../shape/api/interface';
import { ToppingsCategoryItem } from '../../toppingsCategoryItem/api/interface';

export interface FindBundleCake {
  limit?: number;
  skip?: number;
  search?: string;
}

export interface GetBundleCake {
  id: string;
}

export interface CreatePatchBundleCake {
  id?: string;
  labelEn: string;
  labelAr: string;
  descriptionEn: string;
  descriptionAr: string;
  colorCode: string;
  displayBackgroundColor: string;
  displayMode: string;
  shapeId: string;
  flavorId: string;
  toppingId: string;
  activeState: boolean;
}

export interface BundleCake {
  id: string;
  labelEn: string;
  labelAr: string;
  descriptionEn: string;
  descriptionAr: string;
  colorCode: string;
  displayBackgroundColor: string;
  displayMode: string;
  shapeId: string;
  flavorId: string;
  toppingId: string;
  activeState: boolean;
  shape: Shape;
  flavor: Flavor;
  topping_category_item: ToppingsCategoryItem;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updatedBy: string;
}

export interface InitialState {
  data: BundleCake[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
